import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=0597b314&scoped=true&"
import script from "./TermAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermAndCondition.vue?vue&type=style&index=0&id=0597b314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597b314",
  null
  
)

export default component.exports